import { Component, Fragment } from 'react'
import setQuery from 'set-query-string'
import Select from 'react-select'
import { FormattedMessage } from 'react-intl'
import API from '../../api'
import OperatorList from './OperatorsList'
import OperatorMap from './map/OperatorMap'
import { autosuggestStyles } from '../search/helpers'
import { parseQuery, roundPrice, getKindVerbose } from 'utils'
import { trackEcommerce } from 'gtm'
import { convertCurrency } from '../helpers/PriceConverter'

const eCommerceListName = 'Travel Collections'
export default class CollectionItems extends Component {
  constructor(props) {
    super()
    const queryParams = parseQuery() || {}
    let selectedCountries = []

    if(queryParams.country) {
      selectedCountries = props.countriesFilter.filter((item) => {
        const itemId = `${item.id}`
        return Array.isArray(queryParams.country)
          ? queryParams.country.includes(itemId)
          : queryParams.country === itemId
      })
    }
    this.state = {
      isLoading: true,
      isMapActive: false,
      items: [],
      page: 1,
      countries: selectedCountries,
      mapItems: [],
      hasNextPage: false,
    }
  }

  componentDidMount() {
    this.getItems()
    this.getMapItems()
  }

  showMore = () => {
    const { hasNextPage } = this.state
    if(hasNextPage) {
      this.setState(
        (state) => {
          return {
            page: state.page + 1,
          }
        },
        () => this.getItems(true)
      )
    }
  }

  getItems(savePreviousResults) {
    this.setState({
      isLoading: true,
    })
    const { page, countries, items } = this.state
    API(`collections/${this.props.slug}/items/`)
      .get({
        page,
        country_id: countries.map((item) => item.id),
      })
      .then((shops) => {
        const impressions = []
        shops.results.forEach((item, index) => {
          item.impression = {
            name: item.title,
            id: item.id,
            price: roundPrice(
              convertCurrency(item.minPrice, item.currency, 'USD')
            ),
            brand: `${item.title}|${item.affiliateId || 'Non-PADI Operator'}`,
            category: getKindVerbose(item.kind),
            position: index + 1,
          }
          impressions.push({
            ...item.impression,
            list: eCommerceListName,
          })
        })
        trackEcommerce('impression', {
          currencyCode: 'USD',
          impressions,
        })
        if(savePreviousResults) {
          this.setState({
            hasNextPage: !!shops.next,
            items: [...items, ...shops.results],
          })
        } else {
          this.setState({
            hasNextPage: !!shops.next,
            items: shops.results,
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getMapItems() {
    this.setState({
      isLoading: true,
    })
    API(`collections/${this.props.slug}/items/map/`)
      .get({
        country_id: this.state.countries.map((item) => item.id),
      })
      .then((mapItems) => {
        this.setState({
          mapItems,
        })
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleChange(selectedOption) {
    this.setState({ countries: selectedOption, page: 1 }, () => {
      setQuery({ country: this.state.countries.map((item) => item.id) })
      this.getItems()
      this.getMapItems()
    })
  }

  handleMapTrigger = () => {
    this.setState({
      isMapActive: !this.state.isMapActive,
    })
  }

  render() {
    const {
      items,
      countries,
      isLoading,
      isMapActive,
      mapItems,
      hasNextPage,
      page,
    } = this.state
    const { slug } = this.props
    return (
      <Fragment>
        <div className='operators-filter'>
          <div className='operators-filter__dropdown'>
            <i className='font-icons field-icon location-icon' />
            <Select
              onChange={(...args) => {
                this.handleChange(...args)
              }}
              value={countries}
              options={this.props.countriesFilter}
              styles={autosuggestStyles}
              isMulti
              placeholder={
                <FormattedMessage
                  id='all_countries'
                  defaultMessage='All countries'
                />
              }
              isSearchable={false}
              getOptionLabel={(option) => option.title}
              getOptionValue={(option) => option.id}
              isClearable
              className='select-container'
              classNamePrefix='select-container'
            />
          </div>
          <div className='map-button-wrapper' onClick={this.handleMapTrigger}>
            <button className='btn-red'>
              <FormattedMessage id='view_on_map' defaultMessage='View on map' />
            </button>
            <button className='btn-red-invert'>
              <FormattedMessage id='map_view' defaultMessage='Map view' />
            </button>
          </div>
        </div>
        {isMapActive && (
          <OperatorMap
            items={mapItems}
            slug={slug}
            toggleMap={this.handleMapTrigger}
            countryCode={this.props.countryCode}
          />
        )}
        <OperatorList
          isLoading={isLoading}
          items={items}
          showMore={this.showMore}
          page={page}
          hasNextPage={hasNextPage}
          {...this.props}
          eCommerceListName={eCommerceListName}
        />
      </Fragment>
    )
  }
}
